import styled from 'styled-components'

export const OptionContainer = styled.div`
  padding: var(--spacing-inset-size-xs);

`
